import { Box, Tooltip as MuiTooltip, useTheme } from "@mui/material";
import * as React from "react";

export interface TooltipProps {
    text: React.ReactNode | string | undefined;
    children: React.ReactElement<any, any>;
    disableHoverlistener?: boolean;
    position?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start"
        | "right"
        | "top-end"
        | "top-start"
        | "top";
    toolTipMaxWidth?: number;
    tooltipStyle?: "primary" | "secondary";
    useBoldText?: boolean;
    followCursor?: boolean;
}

function Tooltip(props: TooltipProps) {
    const theme = useTheme();
    return props.text ? (
        <MuiTooltip
            title={
                <Box component={"span"} sx={{ whiteSpace: "pre-line" }}>
                    {props.text}
                </Box>
            }
            placement={props.position}
            disableHoverListener={props.disableHoverlistener}
            followCursor={props.followCursor}
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: props.toolTipMaxWidth ?? 300,
                        backgroundColor: props.tooltipStyle === "secondary" ? theme.palette.common.white : "",
                        color: props.tooltipStyle === "secondary" ? theme.palette.primary.dark : "",
                        boxShadow: props.tooltipStyle === "secondary" ? `1px 1px 0.5px 0.5px ${theme.palette.grey[300]}` : "0px",
                        fontWeight: props.useBoldText ? "bold" : "unset",
                    },
                },
            }}
        >
            {props.children}
        </MuiTooltip>
    ) : (
        props.children
    );
}

export default Tooltip;
